__turbopack_context__.v({
  "footerActions": "footer-module-scss-module__OxpWaG__footerActions",
  "footerTags": "footer-module-scss-module__OxpWaG__footerTags",
  "isEmpty": "footer-module-scss-module__OxpWaG__isEmpty",
  "mbl": "footer-module-scss-module__OxpWaG__mbl",
  "mbm": "footer-module-scss-module__OxpWaG__mbm",
  "mbn": "footer-module-scss-module__OxpWaG__mbn",
  "mbs": "footer-module-scss-module__OxpWaG__mbs",
  "mbx": "footer-module-scss-module__OxpWaG__mbx",
  "mbxl": "footer-module-scss-module__OxpWaG__mbxl",
  "mbxxl": "footer-module-scss-module__OxpWaG__mbxxl",
  "ml": "footer-module-scss-module__OxpWaG__ml",
  "mll": "footer-module-scss-module__OxpWaG__mll",
  "mlm": "footer-module-scss-module__OxpWaG__mlm",
  "mln": "footer-module-scss-module__OxpWaG__mln",
  "mls": "footer-module-scss-module__OxpWaG__mls",
  "mlx": "footer-module-scss-module__OxpWaG__mlx",
  "mlxl": "footer-module-scss-module__OxpWaG__mlxl",
  "mlxxl": "footer-module-scss-module__OxpWaG__mlxxl",
  "mm": "footer-module-scss-module__OxpWaG__mm",
  "mn": "footer-module-scss-module__OxpWaG__mn",
  "mrl": "footer-module-scss-module__OxpWaG__mrl",
  "mrm": "footer-module-scss-module__OxpWaG__mrm",
  "mrn": "footer-module-scss-module__OxpWaG__mrn",
  "mrs": "footer-module-scss-module__OxpWaG__mrs",
  "mrx": "footer-module-scss-module__OxpWaG__mrx",
  "mrxl": "footer-module-scss-module__OxpWaG__mrxl",
  "mrxxl": "footer-module-scss-module__OxpWaG__mrxxl",
  "ms": "footer-module-scss-module__OxpWaG__ms",
  "mtl": "footer-module-scss-module__OxpWaG__mtl",
  "mtm": "footer-module-scss-module__OxpWaG__mtm",
  "mtn": "footer-module-scss-module__OxpWaG__mtn",
  "mts": "footer-module-scss-module__OxpWaG__mts",
  "mtx": "footer-module-scss-module__OxpWaG__mtx",
  "mtxl": "footer-module-scss-module__OxpWaG__mtxl",
  "mtxxl": "footer-module-scss-module__OxpWaG__mtxxl",
  "mx": "footer-module-scss-module__OxpWaG__mx",
  "mxl": "footer-module-scss-module__OxpWaG__mxl",
  "mxxl": "footer-module-scss-module__OxpWaG__mxxl",
  "pbl": "footer-module-scss-module__OxpWaG__pbl",
  "pbm": "footer-module-scss-module__OxpWaG__pbm",
  "pbn": "footer-module-scss-module__OxpWaG__pbn",
  "pbs": "footer-module-scss-module__OxpWaG__pbs",
  "pbx": "footer-module-scss-module__OxpWaG__pbx",
  "pbxl": "footer-module-scss-module__OxpWaG__pbxl",
  "pbxxl": "footer-module-scss-module__OxpWaG__pbxxl",
  "pl": "footer-module-scss-module__OxpWaG__pl",
  "pll": "footer-module-scss-module__OxpWaG__pll",
  "plm": "footer-module-scss-module__OxpWaG__plm",
  "pln": "footer-module-scss-module__OxpWaG__pln",
  "pls": "footer-module-scss-module__OxpWaG__pls",
  "plx": "footer-module-scss-module__OxpWaG__plx",
  "plxl": "footer-module-scss-module__OxpWaG__plxl",
  "plxxl": "footer-module-scss-module__OxpWaG__plxxl",
  "pm": "footer-module-scss-module__OxpWaG__pm",
  "pn": "footer-module-scss-module__OxpWaG__pn",
  "prl": "footer-module-scss-module__OxpWaG__prl",
  "prm": "footer-module-scss-module__OxpWaG__prm",
  "prn": "footer-module-scss-module__OxpWaG__prn",
  "prs": "footer-module-scss-module__OxpWaG__prs",
  "prx": "footer-module-scss-module__OxpWaG__prx",
  "prxl": "footer-module-scss-module__OxpWaG__prxl",
  "prxxl": "footer-module-scss-module__OxpWaG__prxxl",
  "ps": "footer-module-scss-module__OxpWaG__ps",
  "ptl": "footer-module-scss-module__OxpWaG__ptl",
  "ptm": "footer-module-scss-module__OxpWaG__ptm",
  "ptn": "footer-module-scss-module__OxpWaG__ptn",
  "pts": "footer-module-scss-module__OxpWaG__pts",
  "ptx": "footer-module-scss-module__OxpWaG__ptx",
  "ptxl": "footer-module-scss-module__OxpWaG__ptxl",
  "ptxxl": "footer-module-scss-module__OxpWaG__ptxxl",
  "px": "footer-module-scss-module__OxpWaG__px",
  "pxl": "footer-module-scss-module__OxpWaG__pxl",
  "pxxl": "footer-module-scss-module__OxpWaG__pxxl",
});
